import { usePreferences, type SearchMode } from "@/store/preferences";

const MODES: { value: SearchMode; label: string }[] = [
  { value: "classic", label: "Classic" },
  { value: "advanced", label: "Advanced" },
];

export function SearchModeToggle() {
  const { searchMode, setSearchMode } = usePreferences();
  return (
    <div className="inline-flex bg-surface-1 border border-surface-3 rounded-lg p-0.5 text-xs">
      {MODES.map((m) => (
        <button
          key={m.value}
          onClick={() => setSearchMode(m.value)}
          className={`px-3 py-1 rounded-md transition-colors ${
            searchMode === m.value
              ? "bg-accent text-white"
              : "text-zinc-400 hover:text-zinc-200"
          }`}
          aria-pressed={searchMode === m.value}
        >
          {m.label}
        </button>
      ))}
    </div>
  );
}
